import { render, staticRenderFns } from "./Heinrich.vue?vue&type=template&id=31b696f4&"
import script from "./Heinrich.vue?vue&type=script&lang=js&"
export * from "./Heinrich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports